import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import './medfind.css';

const Signup: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Signup button clicked');
    console.log('Email:', email);
    console.log('Password:', password ? '•••••••' : '(empty)');
    try {
      console.log('Attempting signup...');
      await createUserWithEmailAndPassword(auth, email, password);
      alert('Signup successful');
      navigate('/login'); // Redirect to Login page after successful signup
    } catch (error) {
      if (error instanceof Error) {
        alert(`Signup failed: Email already exists or Invalid credentials. Please try again.`);
        console.error(error.message);
      } else {
        alert('Signup failed: An unknown error occurred');
        console.error('An unknown error occurred');
      }
    }
  };

  return (
    <div className='d-flex flex-column align-items-center justify-content-center' id='sign-up'>
      <h3>Sign up for an all-exclusive access</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Sign Up</button>
      </form>
      <p>Already have an account? <Link to='/login' style={{ color: '#198754' }}>Login</Link></p>
      <p>Copyright © 2024 MedFind, Inc. All Rights Reserved.</p>
    </div>
  );
};

export default Signup;
